import { Component } from '@angular/core';

@Component({
  selector: 'app-section-numeros-graduadas',
  templateUrl: './section-numeros-graduadas.component.html',
  styleUrls: ['./section-numeros-graduadas.component.scss'],
})
export class SectionNumerosGraduadasComponent {}
